import { jsx as _jsx } from "react/jsx-runtime";
import { breakpoints, getShadowStyle, pxToRems, } from '@awaze/design-system.utils.react';
import { useContext } from 'react';
import styled, { ThemeContext, css } from 'styled-components';
import createTheme from 'styled-variants';
const colourSchemes = ({ theme }) => ({
    white: {
        backgroundColor: theme.ColorWhiteOpacity100,
    },
    lighten5: {
        backgroundColor: theme.ColorWhiteOpacity5,
    },
    lighten10: {
        backgroundColor: theme.ColorWhiteOpacity10,
    },
    lighten20: {
        backgroundColor: theme.ColorWhiteOpacity20,
    },
    darken10: {
        backgroundColor: theme.ColorBlackOpacity10,
    },
    darken20: {
        backgroundColor: theme.ColorBlackOpacity20,
    },
});
const BoxTheme = createTheme('Box').addVariant('colourScheme', colourSchemes);
const BoxThemed = styled.div(BoxTheme);
const StyledBox = styled(BoxThemed) `
  ${({ theme, padding, margin, radius, shadow, boxWidth }) => css `
    padding: ${Array.isArray(padding[0])
    ? padding[0].map((pad) => pxToRems(pad)).join(' ')
    : pxToRems(padding[0])};
    margin: ${pxToRems(margin[0])} 0;
    border-radius: ${radius
    ? Array.isArray(radius)
        ? pxToRems(radius[0])
        : pxToRems(radius)
    : 0};
    box-shadow: ${shadow
    ? getShadowStyle({
        theme,
        depth: Array.isArray(shadow) ? shadow[0] : shadow,
    })
    : 'none'};
    width: ${boxWidth &&
    (isNaN(Number(boxWidth)) ? boxWidth : pxToRems(boxWidth))};

    @media screen and (min-width: ${breakpoints[0]}px) {
      padding: ${Array.isArray(padding[1])
    ? padding[1].map((pad) => pxToRems(pad)).join(' ')
    : pxToRems(padding[1])};
      margin: ${pxToRems(margin[1])} 0;
      box-shadow: ${shadow
    ? getShadowStyle({
        theme,
        depth: Array.isArray(shadow) ? shadow[1] : shadow,
    })
    : 'none'};
      border-radius: ${radius
    ? Array.isArray(radius)
        ? pxToRems(radius[1])
        : pxToRems(radius)
    : 0};
    }
    @media screen and (min-width: ${breakpoints[1]}px) {
      padding: ${Array.isArray(padding[2])
    ? padding[2].map((pad) => pxToRems(pad)).join(' ')
    : pxToRems(padding[2])};
      margin: ${pxToRems(margin[2])} 0;
      box-shadow: ${shadow
    ? getShadowStyle({
        theme,
        depth: Array.isArray(shadow) ? shadow[2] : shadow,
    })
    : 'none'};
      border-radius: ${radius
    ? Array.isArray(radius)
        ? pxToRems(radius[2])
        : pxToRems(radius)
    : 0};
    }
  `}
`;
/**
 * A component for displaying content in a box.
 *
 * There are lots of ways to customise the display of the box, including props for
 *
 * - background
 * - shadow
 * - radius
 * - margin
 * - padding
 * - colourScheme
 * - boxWidth
 * - className
 *
 */
export const Box = ({ children, colourScheme, radius = 8, shadow, padding = [24, 24, 32], margin = [0, 0, 0], boxWidth, className, }) => {
    const themeContext = useContext(ThemeContext);
    return (_jsx(StyledBox, { colourScheme: colourScheme, padding: padding, margin: margin, radius: radius, shadow: shadow, theme: themeContext, boxWidth: boxWidth, className: className, children: children }));
};
//# sourceMappingURL=box.js.map